// Text made safe for an HTML attribute or element body.
export const escapeHtml = (text) => text.replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char])

// A line break inside copy as a block of its own, so it can take height: a `br` cannot be given any (Chromium lays it out as its own object).
export const spaceLineBreaks = (html) => html.replace(/<br\s*\/?>\n?/g, '<span class="app-markdown__break"></span>')

// A table wider than its column scrolls inside the wrapper instead of pushing the page out.
export const wrapTables = (html) => html.replace(/<table>/g, '<div class="app-markdown__table"><table>').replace(/<\/table>/g, '</table></div>')

// The CMS editor wraps a selection as it was made, so a trailing space or line break lands inside the markers (`**text **next`,
// `_text⏎_`, a heading's `**` closed at the start of the next paragraph); CommonMark leaves such markers literal. An opener keeps its own rule: not inside a word.
const EMPHASIS_SLIPS = [
  [/(?<![\w*])\*\*(\S(?:[^*]*?\S)?)(\s+)\*\*/g, '**$1**$2'],
  [/\*\*(\s+)(\S(?:[^*]*?\S)?)\*\*(?![\w*])/g, '$1**$2**'],
  [/(?<![\w_])_(\S(?:[^_]*?\S)?)(\s+)_(?![\w_])/g, '_$1_$2'],
  [/(?<![\w_])_(\s+)(\S(?:[^_]*?\S)?)_(?![\w_])/g, '$1_$2_'],
]

const fixEmphasis = (text) => EMPHASIS_SLIPS.reduce((result, [pattern, replacement]) => result.replace(pattern, replacement), text)

// `##Heading` without the space is a heading the editor meant; a single `#` before a digit (`#1 pick`) is left alone.
const fixHeadings = (text) => text.replace(/^(#{2,6}|#(?=\D))(?=[^#\s])/gm, '$1 ')

// Lines the editor bulleted by hand (`• item`, with a space, a non-breaking space or none) become a list.
const fixBullets = (text) => text.replace(/^[ \t]*[•·▪][ \t ]*/gm, '- ')

// Fenced code is left as written.
const outsideCode = (text, fix) => text.split(/(```[\s\S]*?```)/).map((part, index) => (index % 2 ? part : fix(part))).join('')

// Whitespace moved outside the emphasis markers it was wrapped in.
export const normalizeEmphasis = (text) => outsideCode(text, fixEmphasis)

// The editor's slips put right before parsing: emphasis closed after a space, headings without their space, bullets typed by hand.
export const normalizeMarkdown = (text) => outsideCode(text, (part) => fixBullets(fixHeadings(fixEmphasis(part))))

// Markdown as plain words, for a line that is rendered as text (a card's blurb): links keep their text, emphasis loses its markers.
export const plainText = (text) => (text ?? '')
  .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
  .replace(/(\*\*|__)(.+?)\1/g, '$2')
  .replace(/(^|[\s(])[*_]([^*_\n]+)[*_](?=[\s).,;:!?]|$)/g, '$1$2')
